/* global $, document */
'use strict';

function downloadImage(EVENTS, MODALS) {
	var PubSub = require('pubsub-js');

	var $sharePage = $('#share');
	var $refresh = $sharePage.find('.refresh-link');
	var $termsInput = $sharePage.find('#terms');
	var $downloadBtn = $sharePage.find('.button-download');
	var $downloadBtnContainer = $sharePage.find('.share-button-conteiner');
	var activeButtonClass = 'button-active';

	function bindEvents() {
		$refresh.on('click', function () {
			location.reload();
		});

		$sharePage.on('click', '.js-terms-of-use', function (e) {
			e.preventDefault();
			PubSub.publish(EVENTS.TERMS_OF_USE);
		});

		$sharePage.on('click', '.js-privacy-policy', function (e) {
			e.preventDefault();
			PubSub.publish(EVENTS.PRIVACY_POLICY);
		});

		$termsInput.on('change', function () {
			if ($termsInput.prop('checked')) {
				$downloadBtnContainer.addClass(activeButtonClass);
			}
			else {
				$downloadBtnContainer.removeClass(activeButtonClass);
			}
		});

		$downloadBtn.on('click', function () {
			var a = document.createElement('a');
			var image = $sharePage.find('.img-sharing').find('img');

			if (!$termsInput.prop('checked')) {
				return;
			}

			if ('download' in a) {
				a.href = image.attr('src');
				a.setAttribute('download', 'NikeImage');
				a.innerHTML = 'downloading...';
				document.body.appendChild(a);
				setTimeout(function () {
					a.click();
					document.body.removeChild(a);
				}, 66);
			} else {
				PubSub.publish(EVENTS.MODAL_OPEN, MODALS.DOWNLOAD_DIALOG);
			}
		});
	}

	bindEvents();
}

module.exports = downloadImage;
